// components
import Iconify from '../components/Iconify';

export const TELEGRAM_CHANNEL_URL = 'https://t.me/Holistiqum';
export const TELEGRAM_GROUP_URL = 'https://t.me/+THHcP_Hu5hIzNDAx';

export const ICONS = {
    twitter: 'ant-design:twitter-outlined',
    facebook: 'eva:facebook-fill',
    linkedin: 'eva:linkedin-fill',
    instagram: 'ant-design:instagram-filled',
    email: 'eva:email-fill',
    whatsapp: 'dashicons:whatsapp',
    phone: 'eva:phone-fill',
    tiktok: 'bxl:tiktok',
    youtube: 'bxl:youtube',
    pinterest: 'bxl:pinterest',
    web: 'clarity:world-solid',
    telegram: 'mdi:telegram',
    telegramChannel: 'mdi:bullhorn',
    telegramGroup: 'mdi:account-group',
}

export const SOCIAL_PREFIX = {
    twitter: 'https://twitter.com/',
    facebook: 'https://www.facebook.com/',
    linkedin: 'https://linkedin.com/in/',
    instagram: 'https://www.instagram.com/',
    email: 'mailto:',
    whatsapp: 'https://api.whatsapp.com/send?phone=',
    phone: 'tel:',
    tiktok: 'https://www.tiktok.com/@',
    youtube: 'https://www.youtube.com/@',
    pinterest: 'https://www.pinterest.com/',
    web: 'https://www.',
}

export const SOCIAL_HOLISTIQUM = [
    {
        name: 'FaceBook',
        icon: ICONS.facebook,
        iconElement: <Iconify icon={ICONS.facebook} width={20} height={20} />,
        socialColor: '#1877F2',
        href: 'https://www.facebook.com/HolistiqumLatinoamerica',
    },
    {
        name: 'Instagram',
        icon: ICONS.instagram,
        iconElement: <Iconify icon={ICONS.instagram} width={20} height={20} />,
        socialColor: '#E02D69',
        href: 'https://instagram.com/holistiqumx',
    },
    {
        name: 'Tiktok',
        icon: ICONS.tiktok,
        iconElement: <Iconify icon={ICONS.tiktok} width={20} height={20} />,
        socialColor: '#000000',
        href: 'https://www.tiktok.com/@holistiqumx',
    },
    {
        name: 'Youtube',
        icon: ICONS.youtube,
        iconElement: <Iconify icon={ICONS.youtube} width={20} height={20} />,
        socialColor: '#ff0000',
        href: 'https://www.youtube.com/@holistiqum2281',
    },
    {
        name: 'Telegram (Canal)',
        icon: ICONS.telegram,
        iconElement: <Iconify icon={ICONS.telegram} width={20} height={20} />,
        socialColor: '#26A5E4',
        href: TELEGRAM_CHANNEL_URL,
    },
    {
        name: 'Telegram (Grupo)',
        icon: ICONS.telegramGroup,
        iconElement: <Iconify icon={ICONS.telegramGroup} width={20} height={20} />,
        socialColor: '#26A5E4',
        href: TELEGRAM_GROUP_URL,
    },
];

Object.freeze(ICONS, SOCIAL_PREFIX, SOCIAL_HOLISTIQUM);